<div
  *ngIf="parentFormGroup.controls[controlName]"
  class="component-container"
>
  <div
    class="form-field-label {{type}}"
    *ngIf="label"
  >
    {{label}}
    <span
      *ngIf="isRequired"
      class="required-mark"
    >*</span>
  </div>
  <div class="height-input-container flex flex-row w-full">
    <mat-form-field
      [formGroup]="form"
      appearance="outline"
      class="form-field w-1/3"
      [ngClass]="type ? 'small':''"
      hideRequiredMarker
    >
      <input
        class="input {{type}} number-input"
        formControlName="feet"
        matInput
        [placeholder]="formPlaceholders.feet"
        type="text"
        onlyDigit
      >
    </mat-form-field>
    <mat-form-field
      [formGroup]="form"
      appearance="outline"
      class="form-field w-1/3"
      [ngClass]="type ? 'small':''"
      hideRequiredMarker
    >
      <input
        class="input {{type}} number-input"
        formControlName="inches"
        matInput
        [placeholder]="formPlaceholders.inches"
        type="text"
        onlyDigit
      >
    </mat-form-field>
    <app-dropdown
      class="decimal-dropdown w-1/3"
      [parentFormGroup]="form"
      controlName="cm"
      [options]="cmOptions"
      [placeholder]="formPlaceholders.cm"
      [type]="type"
    />
  </div>
  <div
    class="error-container flex flex-col justify-start w-full">
    <mat-error class="{{type}}"
               *ngIf="error">{{error}}</mat-error>
  </div>
</div>
